import {Component, OnInit, ViewChild} from '@angular/core';
import {language} from '../../../language/vn';
import {ModalDirective} from 'ngx-bootstrap/modal';
@Component({
  selector: 'egov-dvquanlyso',
  templateUrl: './donviquanlyso.component.html',
})
export class DonViQuanLySoComponent implements OnInit {
  @ViewChild('largeModal') public largeModal: ModalDirective;
  public language = language;
  public data: Object[];
  constructor() { }
  public show()
  {

    this.largeModal.show();
  }
  ngOnInit(): void {
    this.data = [
      {
        taskID: 1,
        taskName: 'Chỉnh phủ',
        subtasks: [
          { taskID: 2, taskName: 'Bộ giao thông vận tải'},
          { taskID: 3, taskName: 'Các bộ ban ngành' },
          { taskID: 4, taskName: 'Ủy ban nhân dân các tỉnh thành phố'},
          { taskID: 5, taskName: 'Đơn vị ngoài đường sắt' }
        ]
      },
      {
        taskID: 2,
        taskName: 'Tổng công ty đường sắt việt nam',
        subtasks: [
          { taskID: 2, taskName: 'Đơn vị trực thuộc Tổng Công ty ĐSVN'},
          { taskID: 3, taskName: 'Trung tâm điều hành vận tải GTĐS' },
          { taskID: 4, taskName: 'Trung tâm ứng phó sự cố thiên tai và cứu nạn ĐS'},
          { taskID: 5, taskName: 'Đơn vị ngoài đường sắt' }
        ]
      },
    ]

  }


}
